/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Footnote_ExportInputs */

const en_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** Basic subtitle file export includes common formats (SRT, VTT, TXT). Advanced formats (SCC, MCC, EBU STL) available in our Pro plan.`)
};

const fr_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** L'exportation de fichiers de sous-titres de base inclut les formats courants (SRT, VTT, TXT). Les formats avancés (SCC, MCC, EBU STL) sont disponibles dans notre forfait Pro.`)
};

const de_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** Der grundlegende Export von Untertiteldateien umfasst gängige Formate (SRT, VTT, TXT). Erweiterte Formate (SCC, MCC, EBU STL) sind in unserem Pro-Tarif verfügbar.`)
};

const it_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** L'esportazione di base dei file dei sottotitoli include i formati più comuni (SRT, VTT, TXT). I formati avanzati (SCC, MCC, EBU STL) sono disponibili nel nostro piano Pro.`)
};

const ru_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** Базовый экспорт файлов субтитров включает распространенные форматы (SRT, VTT, TXT). Расширенные форматы (SCC, MCC, EBU STL) доступны в нашем тарифном плане Pro.`)
};

const es_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** La exportación básica de archivos de subtítulos incluye formatos comunes (SRT, VTT, TXT). Formatos avanzados (SCC, MCC, EBU STL) disponibles en nuestro plan Pro.`)
};

const zh_cn2_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** 基本字幕文件导出功能支持常用格式（SRT、VTT、TXT）。高级格式（SCC、MCC、EBU STL）需在我们的专业版套餐中使用。`)
};

const ja_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** 基本的な字幕ファイルのエクスポートには、一般的な形式（SRT、VTT、TXT）が含まれます。高度な形式（SCC、MCC、EBU STL）はProプランでご利用いただけます。`)
};

const hi_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** बुनियादी उपशीर्षक फ़ाइल निर्यात में सामान्य प्रारूप (SRT, VTT, TXT) शामिल हैं। उन्नत प्रारूप (SCC, MCC, EBU STL) हमारे प्रो प्लान में उपलब्ध हैं।`)
};

const pt_pt2_signup_footnote_export = /** @type {(inputs: Signup_Footnote_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`** A exportação básica de arquivos de legenda inclui formatos comuns (SRT, VTT, TXT). Formatos avançados (SCC, MCC, EBU STL) estão disponíveis no nosso plano Pro.`)
};

/**
* | output |
* | --- |
* | "** Basic subtitle file export includes common formats (SRT, VTT, TXT). Advanced formats (SCC, MCC, EBU STL) available in our Pro plan." |
*
* @param {Signup_Footnote_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_footnote_export = /** @type {((inputs?: Signup_Footnote_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Footnote_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_footnote_export(inputs)
	if (locale === "de") return de_signup_footnote_export(inputs)
	if (locale === "it") return it_signup_footnote_export(inputs)
	if (locale === "ru") return ru_signup_footnote_export(inputs)
	if (locale === "es") return es_signup_footnote_export(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_footnote_export(inputs)
	if (locale === "ja") return ja_signup_footnote_export(inputs)
	if (locale === "hi") return hi_signup_footnote_export(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_footnote_export(inputs)
	return en_signup_footnote_export(inputs)
});